module.exports = __webpack_public_path__ + "img/advantage_three.c0592d5b.png";